import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'ko', // 기본 언어
        debug: false,
        resources: {
            en: {
                translation: require('./en/translation.json'), // 경로 수정
            },
            ko: {
                translation: require('./ko/translation.json'), // 경로 수정
            },
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;
